import { useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import { propertyById } from '@kilroy/shared';
import { useSession } from './session';
import { getStatus, subscribe } from '../sync/engine';
import { SyncSheet } from '../components/SyncSheet';
import { useState } from 'react';

/* One header row: who you are, what day it is, and whether your work has left
 * the phone. It replaces five stacked bands — a floating pill, a full-width
 * banner, a date, a subtitle and a narration strip — which together spent a
 * quarter of the screen saying almost nothing.
 *
 * The sync state is a chip rather than a pill on its own row because it is
 * peripheral: there is nothing you can do about it, and the queue holds
 * either way.
 */

export function AppHeader() {
  const { user, propertyId } = useSession();
  const status = useSyncExternalStore(subscribe, getStatus);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const onMap = pathname.startsWith('/map');
  const property = propertyById(propertyId);
  const waiting = status.phase !== 'synced';

  return (
    <>
      <header className="hdr">
        <span className="av">{user.initials}</span>
        <span className="hdr__t">
          <div className="hdr__d">
            {onMap
              ? property.name
              : new Date().toLocaleDateString([], {
                  weekday: 'long',
                  day: 'numeric',
                  month: 'long',
                })}
          </div>
          <div className="hdr__s">
            {onMap ? user.name : `${user.name} · ${property.name}`}
          </div>
        </span>
        <button
          type="button"
          className={`state${waiting ? ' state--wait' : ''}`}
          onClick={() => setOpen(true)}
          aria-label={`Sync: ${status.pill}. Open detail.`}
        >
          {waiting ? status.pill : 'Synced'}
        </button>
      </header>

      {open && (
        <SyncSheet
          onClose={() => setOpen(false)}
          total={status.queued + status.mediaQueued}
        />
      )}
    </>
  );
}
